import { forwardRef } from "react"
import classNames from "classnames"
import SendIcon from "assets/icons/send.svg";
import { useState } from "react";
import { useTranslation } from "react-i18next"
import { disableCopyPasteHandlers, getRandomInRange, handleCopyPaste } from "utils/helper";

const ChatInput = forwardRef(function ({
    id = "",
    loadingReply,
    messages,
    setMessages,
    getBotReply,
    multiChatQuiz = false,
    onTypingStart = () => { },
    onTypingEnd = () => { },
}, ref) {
    const [userMsg, setUserMsg] = useState("");
    const { t } = useTranslation()

    const handleInputChange = ({ target }) => {
        if (target.value.length === 1) {
            onTypingStart(id)
        }
        setUserMsg(target.value)
    }

    const onUserMessage = (msg) => {
        onTypingEnd(id, msg.split(" ")?.length ?? 1)
        const content = msg.trim();
        if (content) {
            const newMsg = { type: "user", content, ...(multiChatQuiz && { id }) };
            const updatedMessages = [...messages, newMsg];
            setMessages(updatedMessages);
            setUserMsg("");
            const timerVal = multiChatQuiz ? getRandomInRange(10, 20) : 0
            getBotReply(updatedMessages, id, timerVal)
        }
    };

    const handleEnterKey = (e) => {
        if (e.key === "Enter") {
            e.preventDefault()
            onUserMessage(userMsg);
        }
        adjustInputHeight(e.key === "Enter")
    };

    const handleSendClick = () => {
        onUserMessage(userMsg)
        adjustInputHeight(true)
    }

    const adjustInputHeight = (resetHeight = false) => {
        const maxHeight = 70
        if (resetHeight) {
            ref.current.style.height = `${30}px`
            ref.current.style.overflowY = "hidden"
        } else {
            const newHeight = Math.min(maxHeight, ref.current.scrollHeight)
            ref.current.style.height = `${newHeight}px`
            if (ref.current.scrollHeight > maxHeight) {
                ref.current.style.overflowY = "scroll"
            } else {
                ref.current.style.overflowY = "hidden"
            }
        }
    }

    return (
        <div className="flex w-full items-center justify-between rounded-[10px] bg-white sm:bg-[#4528120A] px-5 py-[15px] sm:py-[22px]">
            <textarea
                className={classNames(
                    "flex-1 bg-transparent text-lg outline-none placeholder:font-medium resize-none",
                    {
                        "pointer-events-none opacity-50": loadingReply,
                    }
                )}
                ref={ref}
                type="text"
                spellCheck="false"
                autoCorrect="off"
                placeholder={`${t("chat.input_placeholder")}...`}
                value={userMsg}
                onChange={handleInputChange}
                onKeyDown={handleEnterKey}
                onPaste={handleCopyPaste}
                onCopy={handleCopyPaste}
                disabled={loadingReply}
                rows={1}
            />
            <img
                className={classNames("cursor-pointer", {
                    "pointer-events-none opacity-50": loadingReply,
                })}
                onClick={handleSendClick}
                src={SendIcon}
                alt="Send"
            />
        </div>
    )
})

export default ChatInput